import { FC, useEffect } from "react";
import { useSelector } from "react-redux";

import { ISettingOptions, IUserOptions } from "../../../types/interfaces";

import styles from "../headerBtn.module.scss";

const options = [
  { value: "reportId", label: "№ отчета" },
  { value: "date", label: "Дата" },
  { value: "review", label: "Проверка" },
  { value: "delivery", label: "Статус доставки" },
  { value: "rate", label: "Оценка" },
  { value: "geo", label: "Гео" },
  { value: "photo", label: "Фото" },
  { value: "contract", label: "Контракт" },
  { value: "chain", label: "Сеть" },
  { value: "region", label: "Регион" },
  { value: "address", label: "Адрес" },
  { value: "project", label: "Проект" },
  { value: "sv", label: "Супервайзер" },
  { value: "vsv", label: "Виртуальный супервайзер" },
  { value: "merch", label: "Мерчендайзер" },
  { value: "clientId", label: "ID ТТ клиента" },
  { value: "trainee", label: "Стажер" },
  { value: "refined", label: "Нарушитель " },
  { value: "notChecked", label: "Не проверен" },
];

const AdminReportsSettingsSection: FC<ISettingOptions> = ({
  setSelectedSettings,
  selectedSettings,
  setIsCheckedFullInfo,
  isCheckedFullInfo,
}) => {
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);
  const isCanViewDeliveryStatus =
    claims.includes("admin") || claims.includes("reports:delivery-status:view");
  const availableOptions = options.filter(
    (option) => option.value !== "delivery" || isCanViewDeliveryStatus
  );
  const isAllAvailableSelected = availableOptions.every((option) =>
    selectedSettings.includes(option.value)
  );

  const handleChangeCheckbox = (name: string) => {
    const updatedSettings = selectedSettings.includes(name)
      ? selectedSettings.filter((elem: string) => elem !== name)
      : [...selectedSettings, name];
    setSelectedSettings(updatedSettings);
    setIsCheckedFullInfo(
      availableOptions.every((option) => updatedSettings.includes(option.value))
    );
  };

  const handleChangeFullInfoCheckbox = () => {
    if (!isAllAvailableSelected) {
      const allSettings = availableOptions.map((option) => option.value);
      setSelectedSettings(allSettings);
    } else {
      setSelectedSettings([]);
    }
    setIsCheckedFullInfo(!isAllAvailableSelected);
  };

  useEffect(()=>{
    setIsCheckedFullInfo(isAllAvailableSelected);
    // eslint-disable-next-line
  },[]);

  return (
    <div className={styles.settings__block_info}>
      <div className={styles.check__list_block}>
        {availableOptions.map((option) => (
          <div key={option.value} className={styles.check__list_elem}>
            <label className={styles.checkbox__container}>
              <input
                checked={selectedSettings.includes(option.value)}
                type="checkbox"
                onChange={() => handleChangeCheckbox(option.value)}
              />
              <span className={styles.multi__reason_checkmark}></span>
            </label>
            {option.label}
          </div>
        ))}
        <div className={styles.check__list_elem}>
          <label className={styles.checkbox__container}>
            <input
              type={"checkbox"}
              onChange={handleChangeFullInfoCheckbox}
              checked={isCheckedFullInfo || isAllAvailableSelected}
            />
            <span className={styles.multi__reason_checkmark}></span>
          </label>
          Все
        </div>
      </div>
    </div>
  );
};

export default AdminReportsSettingsSection;
